import React, { useState } from 'react'
import styled from 'styled-components'
import { Tabs } from 'antd'
import { menuTax } from 'helpers/constanst'
import HomePageLayout from 'Pages/Layout/PageLayout'
import MerchantInfo from './components/MerchantInfo'
import TaxOrders from './components/Orders'
import TaxList from './components/TaxList'
import SupplierOrders from './components/SupplierOrders'
const { TabPane } = Tabs

type Props = {}

const Tax: React.FunctionComponent<Props> = (props: Props) => {
  const [activeTab, setActiveTab] = useState('1' as string)

  const getTab = () => {
    return (
      <StickyHeader>
        <Tabs onChange={setActiveTab} activeKey={activeTab}>
          {menuTax.map((item: any) => {
            return <TabPane tab={item.name} key={item.value}></TabPane>
          })}
        </Tabs>
      </StickyHeader>
    )
  }

  const getContent = () => {
    switch (activeTab) {
      case '1':
        return <TaxOrders />
      case '2':
        return <SupplierOrders />
      case '3':
        return <TaxList />
      case '4':
        return <MerchantInfo />
      default:
        return <TaxOrders />
    }
  }

  return (
    <>
      <HomePageLayout selected="tax" title="ใบกำกับภาษีเต็มรูปแบบ" label="">
        {getTab()}
        {getContent()}
      </HomePageLayout>
    </>
  )
}

const StickyHeader = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: -25px;
  background-color: #f8fafb;
  z-index: 1;
`

export default Tax
